import styled from "styled-components";

import { SelectedMovieDetailStyledProps as Props } from "./SelectedMovieDetail.types";
import CONSTANTS from "config/constants";

const { mobile, desktop, tablet } = CONSTANTS.BREAKPOINTS;

const SelectedMovieDetailStyled = styled.div<Props>`
  display: flex;
  flex: 1;

  .SelectedMovieDetail {
    &__body {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 2.4rem;

      &__points {
        display: flex;
        align-items: flex-start;
        padding-top: 2.4rem;

        @media (max-width: ${tablet}px) {
          padding-top: 0;
        }

        @media (max-width: ${tablet - 1}px) {
          padding-top: 1.6rem;
        }
      }

      &__image {
        @media (max-width: ${tablet - 1}px) {
          width: 100%;
          background-color: var(--palette-dark-blue-s13-l11);
        }
      }
    }

    &__image {
      &__desktop {
        @media (max-width: ${mobile}px) {
          display: none;
        }
      }

      &__no-desktop {
        display: none;

        @media (max-width: ${mobile}px) {
          display: flex;
        }
      }
    }

    &__header {
      &__data {
        display: flex;
        align-items: center;
        z-index: 1;
        flex: 1;
        padding: 2.4rem 1.2rem;

        @media (max-width: ${tablet}px) {
          padding-top: 1.2rem;
          padding-left: 1.2rem;
          padding-right: 1.2rem;
          padding-bottom: 0;
        }
      }

      &__description {
        padding-left: 1.2rem;
        font-weight: 600;
        z-index: 1;
        display: flex;

        @media (max-width: ${tablet}px) {
          flex-direction: column;
        }

        @media (max-width: ${tablet - 1}px) {
          flex-direction: row;
          justify-content: space-between;
          flex: 1;
        }
      }
    }

    &__movie {
      &__info {
        display: flex;
        gap: 0.6rem;
        align-items: baseline;
      }

      &__language {
        display: flex;
        color: var(--palette-gray-s0-l80);
        margin-right: 0.4rem;
        font-weight: 600;

        @media (max-width: ${tablet - 1}px) {
          font-size: 1rem;
        }
      }

      &__genre {
        color: var(--palette-white);
        font-size: 1.4rem;
        font-weight: 600;
        padding: 0.2rem 0.6rem;
        background-color: var(--palette-gray-s0-l40-a40);
        width: fit-content;
        border-radius: 0.6rem;
        margin-bottom: 0.4rem;

        @media (max-width: ${tablet - 1}px) {
          font-weight: 500;
          font-size: 1rem;
        }
      }

      &__language {
        display: flex;
        color: var(--palette-gray-s0-l80);
        margin-right: 0.4rem;
      }

      &__age {
        margin-left: 0.4rem;
        color: var(--palette-gray-s0-l80);

        &__restricted {
          margin-left: 0.4rem;
          color: var(--palette-red-s95-l65);
        }
      }

      &__title {
        font-size: 1.6rem;
        font-weight: 400;
        color: var(--palette-white);

        @media (max-width: ${mobile}px) {
          font-size: 1.4rem;
          line-height: 1.6rem;
        }
      }

      &__store-and-screen {
        font-size: 1.8rem;
        line-height: 2.4rem;
        padding-top: 0.2rem;
        color: var(--palette-white);

        @media (max-width: ${mobile}px) {
          font-size: 1.8rem;
          line-height: 2rem;
        }
      }

      &__showtime {
        font-size: 2.4rem;
        padding: 0.8rem 0;
        line-height: 2.4rem;
        color: var(--palette-primary);
      }

      @media (max-width: ${mobile}px) {
        font-size: 2rem;
        line-height: 2.2rem;
      }
    }

    &__laurel {
      transform: rotateY(0deg);
      height: 3.2rem;

      path {
        fill: var(--palette-white);
        fill-opacity: 1;
      }

      &__right {
        transform: rotateY(180deg);
      }
    }

    &__points {
      &__text {
        color: var(--palette-white);
        font-size: 1.6rem;
        font-weight: 700;
        line-height: 1.6rem;
        text-align: center;
      }
    }

    &__background {
      position: absolute;
      width: 37.2rem;
      z-index: 0;
      min-height: 14rem;
      background-image: url(${props => props.image});
      background-size: cover;
      background-position-y: center;
      border-radius: 1.6rem;

      @media (max-width: ${desktop}px) {
        min-height: 12rem;
      }

      @media (max-width: ${tablet}px) {
        width: 28.8rem;
        min-height: 16rem;
      }

      @media (max-width: ${tablet - 1}px) {
        width: 100%;
      }

      &::after {
        content: "";
        background-image: linear-gradient(
          180deg,
          transparent,
          var(--palette-dark-blue-s13-l11)
        );
        min-height: 16rem;
        border-radius: 1.6rem;
        position: absolute;
        width: 100%;
        backdrop-filter: blur(0.8rem);

        @media (max-width: ${desktop}px) {
          min-height: 16rem;
        }

        @media (max-width: ${tablet}px) {
          min-height: 18rem;
        }
      }
    }
  }
`;

export default SelectedMovieDetailStyled;
